const Head = () => {
    return (
        <>
            <div className="header">
                <h1 className="title">ToDo List</h1>
            </div>
        </>
    );
}

export default Head;